/**
 * Validator that requires the property to have a non-empty value
 */
export var required = {
    validatorName: 'required',
};
//# sourceMappingURL=required.js.map